"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePhoneNumber = void 0;
/**
 * The "validatePhoneNumber" method tests if a string
 * matches the phone number pattern "(xx) xxxxx-xxxx"
 *
 * @param phoneNumber
 * @returns
 */
const validatePhoneNumber = (phoneNumber) => {
    /**
     * Regex to match string containing a phone number pattern "(xx) xxxxx-xxxx".
     * Get further explanation at https://regex101.com/
     */
    const regexPhonePattern = /^\(\d{2}\) \d{5}-\d{4}$/g;
    return regexPhonePattern.test(phoneNumber);
};
exports.validatePhoneNumber = validatePhoneNumber;
